import { jsNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/nodered-v2.0.0'
import v201 from '@nodes/nodered-v2.0.1'

export default jsNode(
	'nodered',
	{
		'v2.0.0': v200,
		'v2.0.1': v201,
	},
	{ docs: 'https://docs.rolder.app/#/nodered' }
)
